(() => {
  const money = (cents) => {
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.themeCurrency) ||
      "AUD";
    try {
      return (Number(cents) / 100).toLocaleString(undefined, {
        style: "currency",
        currency,
      });
    } catch (_) {
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }
  };

  /* Mobile nav */
  const header = document.querySelector(".pr-header");
  const toggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-nav]");

  const closeMobile = () => {
    if (!nav || !toggle) return;
    nav.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Open menu");
    document.body.classList.remove("pr-nav-open");
  };

  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      document.body.classList.toggle("pr-nav-open", open);
    });
  }

  document.querySelectorAll("[data-nav-item]").forEach((item) => {
    const btn = item.querySelector("[data-nav-subtoggle]");
    if (!btn) return;
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      const open = item.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      document.querySelectorAll("[data-nav-item].is-open").forEach((other) => {
        if (other !== item) {
          other.classList.remove("is-open");
          const otherBtn = other.querySelector("[data-nav-subtoggle]");
          if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
        }
      });
    });
  });

  /* Cart drawer */
  const drawer = document.querySelector("[data-cart-drawer]");
  const drawerBody = document.querySelector("[data-cart-drawer-body]");
  const drawerFoot = document.querySelector("[data-cart-drawer-foot]");
  const drawerSubtotal = document.querySelector("[data-cart-drawer-subtotal]");
  const cartCountEls = document.querySelectorAll("[data-cart-count]");

  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("pr-drawer-open");
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("pr-drawer-open");
  };

  const renderCart = (cart) => {
    cartCountEls.forEach((el) => {
      const count = cart.item_count || 0;
      if (!count) {
        el.hidden = true;
        el.textContent = "0";
      } else {
        el.hidden = false;
        el.textContent = String(count);
      }
    });

    if (!drawerBody) return;

    if (!cart.items || cart.items.length === 0) {
      const kitUrl = (drawer && drawer.getAttribute("data-kit-url")) || "/products/night-shift-sleep-kit";
      drawerBody.innerHTML = `<p class="pr-drawer__empty">Your cart is empty. Start with the Night Kit.</p><a class="pr-btn pr-btn--lamp pr-btn--block" href="${kitUrl}">Get the Night Kit</a>`;
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }

    drawerBody.innerHTML = cart.items
      .map((item) => {
        const price = item.final_price ?? item.price ?? 0;
        const img = item.image || (item.featured_image && item.featured_image.url) || "";
        return `
      <article class="pr-drawer__line">
        <a class="pr-drawer__media" href="${item.url}">
          ${img ? `<img src="${img}" alt="" width="72" height="72" loading="lazy">` : ""}
        </a>
        <div class="pr-drawer__info">
          <a href="${item.url}"><strong>${item.product_title || item.title}</strong></a>
          <div class="pr-drawer__meta">${money(price)} · Qty ${item.quantity}</div>
        </div>
      </article>`;
      })
      .join("");

    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    if (drawerFoot) drawerFoot.hidden = false;
  };

  const fetchCart = () =>
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" }).then((r) => r.json());

  const addToCart = (id, quantity = 1) =>
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(id), quantity: Number(quantity) }),
    }).then(async (r) => {
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.description || data.message || "Add failed");
      return fetchCart();
    });

  document.querySelectorAll("[data-cart-open]").forEach((btn) => {
    btn.addEventListener("click", () => {
      fetchCart().then((cart) => {
        renderCart(cart);
        openCart();
      });
    });
  });

  document.querySelectorAll("[data-cart-close]").forEach((el) => {
    el.addEventListener("click", closeCart);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeCart();
      closeMobile();
    }
  });

  document.addEventListener("click", (event) => {
    if (header && !header.contains(event.target)) closeMobile();
  });

  /* Product page */
  const form = document.querySelector("[data-product-form]");
  const productJsonEl = document.querySelector("[data-product-json]");
  let productData = null;
  if (productJsonEl) {
    try {
      productData = JSON.parse(productJsonEl.textContent);
    } catch (_) {}
  }

  const syncVariant = () => {
    if (!form || !productData) return;
    const selects = [...form.querySelectorAll("[data-option-select]")];
    const values = selects.map((s) => s.value);
    const variant =
      productData.variants.find((v) =>
        values.every((val, i) => String(v[`option${i + 1}`]) === String(val))
      ) || productData.variants[0];
    if (!variant) return;
    const idInput = form.querySelector("[data-product-id]");
    if (idInput) idInput.value = variant.id;
    document.querySelectorAll("[data-product-price]").forEach((el) => {
      el.innerHTML = money(variant.price);
    });
    const addBtn = form.querySelector("[data-add-to-cart]");
    const stickyBtn = document.querySelector("[data-sticky-add]");
    [addBtn, stickyBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? "Add to cart" : "Sold out";
    });
  };

  if (form) {
    form.querySelectorAll("[data-option-select]").forEach((select) => {
      select.addEventListener("change", syncVariant);
    });

    form.querySelectorAll("[data-qty-change]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = form.querySelector("[data-qty-input]");
        if (!input) return;
        const next = Math.max(1, Number(input.value || 1) + Number(btn.dataset.qtyChange));
        input.value = String(next);
      });
    });

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const id = form.querySelector("[data-product-id]")?.value;
      const qty = form.querySelector("[data-qty-input]")?.value || 1;
      const btn = form.querySelector("[data-add-to-cart]");
      if (btn) {
        btn.disabled = true;
        btn.textContent = "Adding…";
      }
      addToCart(id, qty)
        .then((cart) => {
          renderCart(cart);
          openCart();
          if (btn) {
            btn.disabled = false;
            btn.textContent = "Add to cart";
          }
        })
        .catch(() => {
          if (btn) {
            btn.disabled = false;
            btn.textContent = "Add to cart";
          }
          form.submit();
        });
    });
  }

  const stickyAdd = document.querySelector("[data-sticky-add]");
  if (stickyAdd && form) {
    stickyAdd.addEventListener("click", () => form.requestSubmit());
  }

  const sticky = document.querySelector("[data-sticky-atc]");
  const productInfo = document.querySelector(".pr-product__form");
  if (sticky && productInfo && "IntersectionObserver" in window) {
    const ioSticky = new IntersectionObserver(
      ([entry]) => {
        sticky.hidden = entry.isIntersecting;
      },
      { threshold: 0.1 }
    );
    ioSticky.observe(productInfo);
  }

  document.querySelectorAll("[data-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const main = document.getElementById("ProductMainImage");
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        main.srcset = "";
      }
      document.querySelectorAll("[data-thumb]").forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
    });
  });

  /* Reveal: fail open so content never sits invisible in empty frames */
  const reveal = document.querySelectorAll("[data-reveal]");
  const showReveal = (el) => el.classList.add("is-visible");
  if ("IntersectionObserver" in window && reveal.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            showReveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.01, rootMargin: "80px 0px" }
    );
    reveal.forEach((el) => io.observe(el));
    window.setTimeout(() => {
      reveal.forEach((el) => {
        if (!el.classList.contains("is-visible")) showReveal(el);
      });
    }, 1200);
  } else {
    reveal.forEach(showReveal);
  }

  const mq = window.matchMedia("(min-width: 900px)");
  const onBreakpoint = () => {
    if (mq.matches) closeMobile();
  };
  if (mq.addEventListener) mq.addEventListener("change", onBreakpoint);
  else mq.addListener(onBreakpoint);

  document.querySelectorAll("[data-filters-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const panel = document.querySelector("[data-filters-panel]");
      if (!panel) return;
      const open = panel.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  document.querySelectorAll("[data-filters] input[type='checkbox']").forEach((input) => {
    input.addEventListener("change", () => {
      input.closest("form")?.requestSubmit();
    });
  });

  fetchCart().then(renderCart).catch(() => {});
})();
